import React from "react";

import { Product, SpecialPricePeriod } from "@greeter/core";
import { Receipt, ReceiptLine } from "../Receipt";

export type SummaryLine = {
  quantity: number;
  product: Product;
};

export type SummaryProps = {
  lines: ReceiptLine[];
  customTotal?: number;
};

export function Summary({ lines }: SummaryProps) {
  return <Receipt lines={lines} />;
}
